import component from './filters.vue'

export default component
